import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Data Lake browser route (`/explorer/datalake`). Super-admin only —
 * exposes raw subsidiary storage. Lazy-loaded (pulls in the xlsx/papaparse
 * preview parsers) so it stays off the initial authenticated bundle.
 */
const DatalakePage = lazy(() => import('~/features/explorer/pages/datalake-page'));

// Persist the page-local subsidiary scope in the URL (opaque `?sc=`).
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/datalake')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DatalakePage />
    </Suspense>
  );
}
